import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { NOTIFICATION_CATEGORY, type Notification, type NotificationCategory } from 'types/modules/notification-center/notification'

import NotificationBadgeCircle from './NotificationBadgeCircle'
import { SEVERITY_BADGE_SIZE } from './notificationCenterConstants'
import { severityOf } from './notificationCenterViews'

/** Icon carries the category; the badge tint carries the severity. */
const CATEGORY_ICON: Readonly<Record<NotificationCategory, typeof AutorenewOutlinedIcon>> = Object.freeze({
  [NOTIFICATION_CATEGORY.JOB]: AutorenewOutlinedIcon,
  [NOTIFICATION_CATEGORY.CUSTOMER_EVENT]: PersonOutlineOutlinedIcon,
})

type NotificationSeverityBadgeProps = {
  notification: Notification
  size?: number
}

const NotificationSeverityBadge = ({ notification, size = SEVERITY_BADGE_SIZE }: NotificationSeverityBadgeProps) => {
  const theme = useTheme()
  const CategoryIcon = CATEGORY_ICON[notification.category]

  return (
    <NotificationBadgeCircle color={theme.palette[severityOf(notification)].main} size={size}>
      <CategoryIcon fontSize="small" />
    </NotificationBadgeCircle>
  )
}

export default NotificationSeverityBadge
